const KEY = 'crm-mcp-login-return';
const CONSENT_PATH = '/app/mcp/authorize';

export function rememberMcpLoginReturn(path) {
  const url = new URL(path, window.location.origin);
  if (url.origin !== window.location.origin || url.pathname !== CONSENT_PATH)
    return;
  if (url.search.length > 8192) return;
  sessionStorage.setItem(
    KEY,
    JSON.stringify({
      path: url.pathname + url.search,
      expiresAt: Date.now() + 15 * 60_000,
    })
  );
}

export function consumeMcpLoginReturn() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    sessionStorage.removeItem(KEY);
    if (
      !saved ||
      saved.expiresAt < Date.now() ||
      typeof saved.path !== 'string'
    )
      return null;
    const url = new URL(saved.path, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname !== CONSENT_PATH)
      return null;
    return url.pathname + url.search;
  } catch {
    return null;
  }
}
